import { render, staticRenderFns } from "./RouteLoading.vue?vue&type=template&id=45eb4200&scoped=true"
import script from "./RouteLoading.vue?vue&type=script&lang=js"
export * from "./RouteLoading.vue?vue&type=script&lang=js"
import style0 from "./RouteLoading.vue?vue&type=style&index=0&id=45eb4200&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45eb4200",
  null
  
)

export default component.exports